// extracted by mini-css-extract-plugin
export default {"containerTitle":"Game_containerTitle__Kqm+x","containerHost":"Game_containerHost__VRKJl"};